import { Dispatch } from "redux";
import { setOrganizationDetails } from "@redux/actions/organization-details-actions";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { OrganizationConfig } from "@idw-types/data/organization-config";
import { updateAxnCompanyRequest } from "@requests/axnadmin-core";

export const updateOrganizationDetailsReduxRequest = (dispatch: Dispatch) => async (
    organizationConfig: OrganizationConfig
) => {
    const { data, error, body } = await updateAxnCompanyRequest(organizationConfig);
    if (data?.transferObject) {
        dispatch(setOrganizationDetails({
            ...organizationConfig,
            ...data.transferObject,
            permissions: organizationConfig.permissions
        }));
        displaySuccessModal(
            dispatch,
            resources.requests.updateOrganizationDetails.success.title,
            resources.requests.updateOrganizationDetails.success.message
        );
        return {
            ...data.transferObject,
            permissions: organizationConfig.permissions
        };
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateOrganizationDetails.error.title,
            resources.requests.updateOrganizationDetails.error.message,
            null,
            null,
            body
        );
    }

    return null;
};